/* ODDAY Product Page */
if (!customElements.get('odday-product')) {
  class OddayProduct extends HTMLElement {
    connectedCallback() {
      try { this.product = JSON.parse(this.querySelector('[data-product-json]').textContent); } catch (e) { return; }
      this.idInput = this.querySelector('[data-variant-id]');
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.money = (c) => {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: window.Shopify?.currency?.active || 'INR' }).format(c / 100); }
        catch (e) { return (c / 100).toFixed(2); }
      };
      this.variant = this.product.variants.find((v) => v.id == this.idInput.value) || this.product.variants[0];
      this.selected = [...(this.variant.options || [])];

      this.bindGallery();
      this.bindOptions();
      this.bindQty();
      this.bindForm();
      this.bindFinder();
      this.bindGift();
      this.bindMeter();
      this.bindMobileBar();
      this.updateAvailability();
    }

    /* gallery */
    bindGallery() {
      const main = this.querySelector('[data-zoom]');
      this.querySelectorAll('[data-thumb]').forEach((b) => b.addEventListener('click', () => this.showMedia(b.dataset.thumb)));
      if (!main) return;
      main.addEventListener('click', () => main.classList.toggle('is-zoom'));
      main.addEventListener('mousemove', (e) => {
        const r = main.getBoundingClientRect();
        main.style.setProperty('--zx', ((e.clientX - r.left) / r.width) * 100 + '%');
        main.style.setProperty('--zy', ((e.clientY - r.top) / r.height) * 100 + '%');
      });
      main.addEventListener('mouseleave', () => main.classList.remove('is-zoom'));
      let sx = null;
      main.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true });
      main.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const d = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(d) < 50) return;
        const slides = [...this.querySelectorAll('[data-media]')];
        const i = slides.findIndex((s) => s.classList.contains('is-on'));
        const n = slides[(i + (d < 0 ? 1 : -1) + slides.length) % slides.length];
        if (n) this.showMedia(n.dataset.media);
      });
    }
    showMedia(id) {
      if (!id) return;
      this.querySelectorAll('[data-media]').forEach((s) => s.classList.toggle('is-on', s.dataset.media == id));
      this.querySelectorAll('[data-thumb]').forEach((b) => b.classList.toggle('is-on', b.dataset.thumb == id));
    }

    /* options */
    bindOptions() {
      this.querySelectorAll('[data-opt]').forEach((b) => b.addEventListener('click', () => this.pick(+b.dataset.opt, b.dataset.value)));
    }
    pick(idx, value) {
      this.selected[idx] = value;
      const group = this.querySelector(`[data-option-group="${idx}"]`);
      group?.querySelectorAll('[data-opt]').forEach((x) => x.classList.toggle('is-on', x.dataset.value === value));
      const lab = group?.querySelector('[data-option-label]');
      if (lab) lab.textContent = value;
      const v = this.product.variants.find((v) => v.options.every((o, i) => o === this.selected[i]));
      this.variant = v || null;
      if (v) {
        this.idInput.value = v.id;
        if (v.featured_media) this.showMedia(v.featured_media.id);
        const url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
      this.updatePrice();
      this.updateAvailability();
    }
    updatePrice() {
      const v = this.variant;
      if (!v) return;
      this.querySelector('[data-price]').textContent = this.money(v.price);
      const m = this.querySelector('[data-price-m]'); if (m) m.textContent = this.money(v.price);
      const sp = this.querySelector('[data-price-sticky]'); if (sp) sp.textContent = this.money(v.price);
      const cmp = this.querySelector('[data-compare]'), off = this.querySelector('[data-off]'), badge = this.querySelector('[data-save-badge]');
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      cmp.hidden = off.hidden = !sale;
      if (sale) {
        const pct = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
        cmp.textContent = this.money(v.compare_at_price);
        off.textContent = `Save ${pct}%`;
        if (badge) badge.textContent = `-${pct}%`;
      }
      if (badge) badge.hidden = !sale;
    }
    updateAvailability() {
      const add = this.querySelector('[data-add]'), label = this.querySelector('[data-add-label]');
      const ok = this.variant && this.variant.available;
      if (add) add.disabled = !ok;
      if (label) label.textContent = !this.variant ? 'Unavailable' : ok ? label.dataset.orig || 'Add to bag' : 'Sold out';
      const sAdd = this.querySelector('[data-sticky-add]'), sLabel = this.querySelector('[data-sticky-label]');
      if (sAdd) sAdd.disabled = !ok;
      if (sLabel) sLabel.textContent = !this.variant ? 'Unavailable' : ok ? 'Add to bag' : 'Sold out';
      const sSelect = this.querySelector('[data-sticky-select]');
      if (sSelect && this.variant) sSelect.value = this.variant.id;
      /* grey out sold-out values for single-option products */
      if (this.product.options.length === 1) {
        this.querySelectorAll('[data-opt="0"]').forEach((b) => {
          const v = this.product.variants.find((x) => x.options[0] === b.dataset.value);
          b.classList.toggle('is-sold', !!v && !v.available);
        });
      }
    }

    /* qty + submit */
    bindQty() {
      const inp = this.querySelector('[data-qty-input]');
      this.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => { inp.value = Math.max(1, (+inp.value || 1) + +b.dataset.qty); }));
    }
    bindForm() {
      if (!this.form) return;
      this.form.addEventListener('submit', async (e) => {
        e.preventDefault();
        await this.add();
      });
    }
    async add() {
      const err = this.querySelector('[data-error]');
      err.hidden = true;
      const sizeGroup = this.querySelector('[data-size-group]');
      if (!this.variant) {
        err.textContent = 'Please pick an available combination.'; err.hidden = false; return;
      }
      if (!this.variant.available) return;
      const props = {};
      const gift = this.querySelector('[data-gift]');
      if (gift?.checked) {
        props['Gift wrap'] = 'Yes';
        const note = this.querySelector('[data-gift-note]')?.value.trim();
        if (note) props['Note for kid'] = note;
      }
      const btn = this.querySelector('[data-add]');
      btn.classList.add('is-loading'); btn.disabled = true;
      try {
        await window.ODD.addToCart({ id: this.variant.id, quantity: +this.querySelector('[data-qty-input]').value || 1, properties: props });
      } catch (x) {
        err.textContent = x?.description || x?.message || 'Could not add to bag.'; err.hidden = false;
      }
      btn.classList.remove('is-loading'); btn.disabled = !this.variant.available;
      if (sizeGroup) sizeGroup.classList.remove('is-shake');
    }

    /* size finder */
    bindFinder() {
      const box = this.querySelector('[data-finder]');
      const toggle = this.querySelector('[data-finder-toggle]');
      if (!box || !toggle) return;
      const hs = (this.dataset.sizeHeights || '').split(',').map(Number).filter(Boolean);
      const as = (this.dataset.sizeAges || '').split(',').map(Number).filter(Boolean);
      const group = box.closest('[data-option-group]');
      const idx = +group.dataset.optionGroup;
      const btns = [...group.querySelectorAll('[data-opt]')];
      const hgt = box.querySelector('[data-hgt]'), age = box.querySelector('[data-age]'), grow = box.querySelector('[data-grow]');
      const calc = () => {
        const h = +hgt.value, a = +age.value;
        box.querySelector('[data-hv]').textContent = h + ' cm';
        box.querySelector('[data-av]').textContent = a + ' yrs';
        let i = hs.findIndex((x) => h < x); if (i < 0) i = hs.length;
        let ai = as.findIndex((x) => a <= x); if (ai < 0) ai = as.length;
        if (ai > i) i = Math.round((i + ai) / 2);
        const msg = box.querySelector('[data-fit-msg]');
        msg.dataset.base = msg.dataset.base || msg.textContent;
        let m = msg.dataset.base;
        if (grow.checked) { if (i < btns.length - 1) { i++; m = 'One size up, so it lasts all year'; } else m = 'Already our biggest size'; }
        i = Math.min(i, btns.length - 1);
        const b = btns[i];
        if (!b) return;
        box.querySelector('[data-fit-size]').textContent = b.dataset.value;
        msg.textContent = m;
        box.querySelector('[data-kid]').setAttribute('height', 60 + (h - 95) * 0.8);
        this.pick(idx, b.dataset.value);
      };
      toggle.addEventListener('click', () => { box.hidden = !box.hidden; if (!box.hidden) calc(); });
      [hgt, age].forEach((el) => el.addEventListener('input', calc));
      grow.addEventListener('change', calc);
    }

    bindGift() {
      const g = this.querySelector('[data-gift]'), n = this.querySelector('[data-gift-note]');
      g?.addEventListener('change', () => { if (n) n.hidden = !g.checked; });
    }
    bindMeter() {
      const m = this.querySelector('[data-meter]');
      if (!m) return;
      const go = () => m.querySelectorAll('[data-w]').forEach((i) => (i.style.width = i.dataset.w + '%'));
      if (!('IntersectionObserver' in window)) return go();
      const io = new IntersectionObserver((es) => { if (es[0].isIntersecting) { go(); io.disconnect(); } }, { threshold: 0.3 });
      io.observe(m);
    }
    bindMobileBar() {
      const bar = this.querySelector('[data-sticky-bar]') || this.querySelector('[data-mbar]'), add = this.querySelector('[data-add]');
      if (!bar || !add) return;
      new IntersectionObserver((es) => bar.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0)).observe(add);
      const stickyAdd = bar.querySelector('[data-sticky-add]') || bar.querySelector('[data-mbar-add]');
      stickyAdd?.addEventListener('click', () => this.add());
      const stickySelect = bar.querySelector('[data-sticky-select]');
      stickySelect?.addEventListener('change', (e) => {
        const targetVar = this.product.variants.find((v) => v.id == e.target.value);
        if (targetVar) {
          targetVar.options.forEach((val, idx) => this.pick(idx, val));
        }
      });
    }
  }
  customElements.define('odday-product', OddayProduct);
}
